(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-showcase"] && !Shopify.designMode) return;
  try {
    
// 2. Interactive Link Showcase
class WDT_link_showcase extends HTMLElement {
  constructor() {
    super();
    this.wdtMainItems = this.querySelectorAll('.collection_showcase_content');
    this.wdtMainitem = Array.from(this.querySelectorAll('.wdt-link-showcase-item'));
    this.init();
  }

  init() {
    this.wdtMainitem.forEach(wdtItem => {
      let wdtImageItems = wdtItem.querySelectorAll('.wdt-link-follow-content');
      wdtItem.addEventListener('mousemove', (e) => {
        let x = e.offsetX;
        let y = e.offsetY;
        wdtImageItems.forEach(imageItems => {
          imageItems.style.left = `${x}px`;
          imageItems.style.top = `${y}px`;
        });
      });
    });
  }
}

customElements.define('wdt-link-interactive', WDT_link_showcase);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');     
      this.headerIsOnSticky = this.getAttribute('data-sticky-type') === 'sticky';
    
      if (this.headerIsOnSticky) {
          this.header.classList.add('wdt-scroll-sticky');
      
          const wdtHeaderEle = document.querySelector('.wdt-scroll-sticky');
          const wdt_MaxScroll = 800;
          let wdtHeaderHeight = this.header.offsetHeight;
          let position = window.scrollY;
         
          const updateHeaderHeight = () => {
              wdtHeaderHeight = this.header.offsetHeight;
          };
        
          window.addEventListener('scroll', function() {
            var wdtScrollTop = window.scrollY;             
            if ((wdtScrollTop > 0 && position > wdt_MaxScroll) && wdtScrollTop > position) {
                wdtHeaderEle.classList.add('wdt-header-top');
                wdtHeaderEle.style.top = `-${wdtHeaderHeight}px`;
            } else {
                wdtHeaderEle.classList.remove('wdt-header-top');
                wdtHeaderEle.style.top = '0px';
            }
            position = wdtScrollTop;
          });

        window.addEventListener('resize', updateHeaderHeight);
        
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);


  document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-target]").forEach((button) => {
    button.addEventListener("click", function () {
      const targetSelector = this.getAttribute("data-target");
      const offcanvasElement = document.querySelector(targetSelector);

      if (offcanvasElement) {
        const bsOffcanvas = new bootstrap.Offcanvas(offcanvasElement);
        bsOffcanvas.show();
      }
    });
  });

    document.querySelectorAll('a[role="button"]').forEach(button => {
  button.addEventListener('keydown', function(e) {
    if (e.code === 'Space' || e.key === ' ') {
      e.preventDefault(); 
      this.click(); 
    }
  });
});

    
});

  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"]) return;
  try {
    
  class NewsletterModal extends HTMLElement {
    constructor() {
      super();
      this.newsletterModal = null;
      this.closeButton = null;
    }
    connectedCallback() {
      this.initModal();
    }
    initModal() {
      this.newsletterModal = this.querySelector("#newsletter_model");
      this.closeButton = this.querySelector("#newsletter_model .btn-close");

      if (!this.newsletterModal || this.getCookie("newsletter_shown")) {
        return;
      }

      const isThemeEditor = window.Shopify && window.Shopify.designMode;
      const delay = parseInt(this.newsletterModal.dataset.delay || "0", 10);
      const expiryDays = parseInt(this.newsletterModal.dataset.expiry || "30", 10);

    // Detect Homepage
      const isHomePage =
      window.location.pathname === "/" ||
      window.location.pathname === "";

    // Detect if this page load is a browser refresh
    const navEntries = performance.getEntriesByType("navigation");
    const isRefresh =
      navEntries.length && navEntries[0].type === "reload";

    // Show popup only on homepage OR after a page refresh
    if (!isHomePage && !isRefresh && !isThemeEditor) {
      return;
    }

    setTimeout(() => {
      this.showModal();

      if (!isThemeEditor) {
        this.setCookie("newsletter_shown", "true", expiryDays);
      }
    }, delay);

    this.initEventListeners();
  }
    initEventListeners() {
      if (this.closeButton) {
        this.closeButton.addEventListener("click", () => this.hideModal());
      }
      document.addEventListener("click", (event) => {
        if (!event.target.closest(".popup-modal, .trigger")) {
          this.hideModal();
        }
      });
    }
    showModal() {     
      this.newsletterModal.classList.remove("d-none");
      this.newsletterModal.classList.add("d-flex");
    }
    hideModal() {    
      if (this.newsletterModal) {
        this.newsletterModal.classList.remove("d-flex");
        this.newsletterModal.classList.add("d-none");
        this.newsletterModal.style.setProperty("display", "none", "important");
      }
      const popupModal = this.querySelector(".popup-modal");
      if (popupModal) {
        popupModal.style.setProperty("display", "none", "important");
      }
    }
    getCookie(name) {
      const value = "; " + document.cookie;
      const parts = value.split("; " + name + "=");
      if (parts.length === 2) return parts.pop().split(";").shift();
    }
    setCookie(name, value, days) {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = `${name}=${value || ""}${expires}; path=/`;
    }
  }

  customElements.define("newsletter-modal", NewsletterModal);
  document.addEventListener("DOMContentLoaded", () => {    
    const newsletterModalElement = document.querySelector("newsletter-modal");    
  });

  } catch(e) { console.error(e); }
})();
})();
